const routes = [
    {
        name: 'listarFormasAtendimentos',
        path: 'formas',
        alias: 'formas/index',
        component: () => import('../views/Listar')
    },
    {
        name: 'adicionarFormaAtendimento',
        path: 'formas/adicionar',
        component: () => import('../views/Adicionar')
    },
    {
        name: 'editarFormaAtendimento',
        path: 'formas/editar/:id',
        component: () => import('../views/Editar')
    },
    {
        name: 'visualizarFormaAtendimento',
        path: 'formas/visualizar/:id',
        component: () => import('../views/Visualizar')
    }
   
]

export default routes


